// extracted by mini-css-extract-plugin
module.exports = {"garmentPriceContainer":"style-module--garmentPriceContainer--3AL2m","spacer":"style-module--spacer--2fM2W","garmentPricePrice":"style-module--garmentPricePrice--1CboT"};